import { HttpEvent, HttpInterceptorFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import {catchError, switchMap, filter, take} from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<string | null>(null);

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const addAuthToken = (request: HttpRequest<any>): HttpRequest<any> => {
    const token = authService.getToken();
    if (token) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return request;
  };

  const handle401Error = (request: HttpRequest<any>): Observable<HttpEvent<any>> => {
    if (!isRefreshing) {
      isRefreshing = true;
      refreshTokenSubject.next(null);

      return authService.refreshToken().pipe(
        switchMap((response: any) => {
          isRefreshing = false;
          const newToken = response.token;
          refreshTokenSubject.next(newToken);
          return next(addAuthToken(request));
        }),
        catchError((error) => {
          isRefreshing = false;
          refreshTokenSubject.next(null);
          if (error.status === 401) {
            authService.redirectToAuth();
          }
          return throwError(() => error);
        })
      );
    } else {
      return refreshTokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap((token) => next(addAuthToken(request)))
      );
    }
  };

  if (req.url.endsWith('/token')) {
    return next(req);
  }

  const authReq = addAuthToken(req);

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return handle401Error(req);
      } else {
        return throwError(() => error);
      }
    })
  );
};
